import React, { useState } from "react";
import play from "../../assets/images/stuff/play.svg";
import playSeen from "../../assets/images/stuff/playSeen.svg";
import style from "./VideoSlide.module.css";
import VideoComponent from "../VideoComponent/VideoComponent";

const VideoSlide = ({
  video,
  setOpenVideo,
  setVideo,
  phase,
  todayTimestamp,
  timestamp,
}) => {
  const [open, setOpen] = useState(false);

  const handleVideo = () => {
    if (todayTimestamp > timestamp && phase > 1) {
        setOpenVideo(true);
      setVideo(video);
    };
    
  };
  return (
    <>
      <div className={style.contentVideo}
      id={video.videoId}
      >
        <img
          src={video.img}
          alt="video"
          className={style.poster}
          onPointerUp={handleVideo}
        />
        <img
          src={video.seen ? playSeen : play}
          alt="play"
          className={style.play}
          onPointerUp={handleVideo}
        />
        <span className={style.title}>{video.title}</span>
      </div>{" "}
      {/* {open && <VideoComponent video={video} setOpen={setOpen}/>} */}
    </>
  );
};

export default VideoSlide;
